import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as DESUI from "react-bootstrap";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import {  Row, Col, Container,Button } from "react-bootstrap";
import allowNumbersOnly, { generatePdf, exportToExcel, datetime } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { FaRegSave } from "react-icons/fa";

export default function Hrmsdata() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [searchText1, setSearch1] = useState("");
 

  const formik = useFormik({
    initialValues: {
        cfms_id: ""
     
    },

  })
const [employeedata, setemployeedata] = useState(null);
const [emppositiondata, setemppositiondata] = useState(null);
const[currentdate,setcurrentdate] =useState('');
  const[currenttime,setcurrenttime] =useState('');
 

  useEffect(() => {
   datetime(setcurrentdate,setcurrenttime);
  }, []);


      const filteredDataa =
      searchText1.length > 0 && employeedata?.length
        ? employeedata.filter((item) => {
            return (
              item &&
              Object.keys(item).some((key) => {
                const value = item[key];
                return (
                  value !== null &&
                  value
                    .toString()
                    .toLowerCase()
                    .includes(searchText1.toLowerCase())
                );
              })
            );
          })
        : employeedata;

 const getdata = (val) => {
    if (!val) { return; }let params = { cfmsId: val}; store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.gethrmsempdata(params)
      .then((res) => {
        store.dispatch({ type: "HIDE_SPINNER" });
        if (res.data && res.data.SCODE === "01") { setemployeedata(res.data?.EMP_DATA); setemppositiondata(res.data?.EMP_POSITION_DETAILS); } else { setemployeedata(null); setemppositiondata(null); showAlertMessage(res.data?.SDESC, "warning", () => { formik.setFieldValue("cfms_id", ""); }); }
      }) .catch((error) => { store.dispatch({ type: "HIDE_SPINNER" });
 
  if (error.response?.request?.responseText) { showAlertMessage(error.response.request.responseText, "warning",()=>{ formik.setFieldValue("cfms_id",""); });
  } else { showAlertMessage("An error occurred while fetching data.", "error",()=>{ formik.setFieldValue("cfms_id",""); }); }
}) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); }); };
  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'  >
        <div className='sa-title'>
          <h2>HRMS Employee <span> Details</span></h2>
        </div>
      </Container>

      <DESUI.Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>

           <div className="mandal-container p-4 ">
                                <Row>
                                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}> <div className="d-flex flex-column"> <label className="mb-1 fw-bold">Cfms Id</label> <Field type="text" name="cfms_id" className="form-control" maxLength="8" onKeyPress={(e) => { allowNumbersOnly(e); }} /> </div> </Col>
                                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}> <div className="bottom-buttons mt-4"> <Button variant="" size="sm" className="save-btn" onClick={() => getdata(formik.values.cfms_id)}> Get Data <FaRegSave className="ms-1 s-icon" /> </Button> </div> </Col>
                                </Row>
                                </div>


          </Form>
        </FormikProvider><br />
       

        <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} >
                  <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText1} onChange={(event) => setSearch1(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div>
              </Col>

                 <Col className=" mb-2 " > <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "HRMSEmployeesDataReport")} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button> <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "HRMSEmployeesDataReport")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
              
                                  </Col>
            </Row>
              <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-2 px-2 " >
                     <span className="style-1">HRMS Employee Details</span> <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>        
                  </div>
            <div id="table-scroll"className="table-scroll">
              <div className="table-wrap">
            <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >
                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                  
                  <tr className="text-center only-export">
                  <th colSpan="9" style={{ backgroundColor: "#d4e3d8", color: "black" }}>
                    <span className="style-1">HRMS Employee Details </span>
                 </th></tr>

                  <tr className="only-export"><th  colSpan="9"><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>
                  <tr className="text-center">
                    <th> Sl No. </th> <th>Employee Id </th> <th> Employee Name  </th> <th> Position  </th> <th>DDO  Name</th> <th>Organisation  Name</th> <th> Date of Birth  </th> <th> Mobile  </th> <th> Gender  </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDataa?.length === 0 || filteredDataa?.length === undefined ? ( <tr> <td className="text-center" colSpan={9}> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr> ) : ( (() => { return filteredDataa?.map((detail, i) => { return (
                          <tr key={i}> <td style={{textAlign:"center"}}>{i+1}</td> <td>{detail.employeeid}</td> <td>{detail.surname}{" "}{detail.name}</td> <td>{detail.position_id}{"-"}{detail.position_name}</td> <td>{detail.ddocode}{"-"}{detail.ddo_desc}</td> <td>{detail.org_id}{"-"}{detail.org_name}</td> <td>{detail.dob}</td> <td>{detail.mobileno}</td> <td>{detail.gender_desc}</td> </tr>
                        );
                      });
                    })()
                  )}
                </tbody>

              </table>

</div>
            </div>

           

<AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
      </DESUI.Container >
    </>
  );
};



